import { post, put, get } from '@/services/http'
import { getUserToken } from '@/services/authService'
import { isEmpty } from '@/utils/StringUtil'

export function savePart(data) {
  return post(`/api/v1/parts`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function fetchPart(id) {
  return get(`/api/v1/parts/fetch?partId=${id}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function fetchPartsByCriteria(keyword, size, page, sort) {
  return get(`/api/v1/parts/fetch-by-criteria?size=${size}&page=${page}&sort=${sort}${!isEmpty(keyword) ? `&keyword=${keyword}` : ''}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function fetchAllCategories() {
  return get(`/api/v1/parts/fetch/all/enabled/categories`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function fetchAllPartsByCategory(c, cu, serviceCategoriesKeys) {
  return get(`/api/v1/parts/fetch/by/category?category=${c}${cu && cu !== undefined ? '&contactUsername=' + cu : ''}${serviceCategoriesKeys ? `&serviceCategories=${serviceCategoriesKeys}`: ''}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function updatePartState(pId, state) {
  return put(`/api/v1/parts/update/part-state?id=${pId}&state=${state}`, {empty: true}, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function savePredefinedServicesToPart(pId, body) {
  return put(`/api/v1/parts/save/predefined/services/to-part?id=${pId}`, body, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function getAllAvailablePredefinedServicesByServiceType() {
  return get(`/api/v1/parts/get/available/predefined/services`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}